(function () {
  function markImageLoaded(container) {
    container.classList.add('is-loaded');
  }

  function initBlurUp(root) {
    var scope = root || document;
    scope
      .querySelectorAll('.reach-media--blur-up:not([data-reach-blur-init]), .reach-blur-image:not([data-reach-blur-init])')
      .forEach(function (container) {
        container.dataset.reachBlurInit = 'true';
        var main = container.querySelector('.reach-media__main, .reach-blur-image__main');
        if (!main) return;

        if (main.complete && main.naturalWidth > 0) {
          markImageLoaded(container);
          return;
        }

        main.addEventListener('load', function () {
          markImageLoaded(container);
        }, { once: true });

        main.addEventListener('error', function () {
          markImageLoaded(container);
        }, { once: true });
      });
  }

  function initReachMedia(root) {
    var scope = root || document;
    scope.querySelectorAll('.reach-media--has-video:not([data-reach-media-init])').forEach(function (media) {
      var video = media.querySelector('.reach-media__video');
      if (!video) return;

      media.dataset.reachMediaInit = 'true';

      var markReady = function () {
        media.classList.add('is-ready');
      };

      if (video.readyState >= 2) {
        markReady();
        return;
      }

      video.addEventListener('canplay', markReady, { once: true });
      video.addEventListener('loadeddata', markReady, { once: true });
    });

    initBlurUp(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReachMedia();
    });
  } else {
    initReachMedia();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReachMedia(event.target);
  });
})();
